<template>
  <div>
    <v-container grid-list-md fluid v-if="hasInterview && !formEditing">
      <v-layout row wrap>
        <v-flex md6 xs12>
          <v-card>
            <v-card-title class="pb-0">
              <v-layout align-center justify-space-between fill-height>
                <v-flex xs8>
                  <h5 class="headline text-uppercase text-green">{{ 'app.interview.general_information' | trans }}</h5>
                </v-flex>
                <v-flex xs4>
                  <permission-button color="primary" :container-class="`pull-right`"
                                     @click="editForm('general_information')"
                                     :permission="`patient_interview_manage`"
                                     :tooltip="{top: true, bottom: false, attach: false}"
                  >{{
                      'app.edit'|trans
                    }}
                  </permission-button>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-divider></v-divider>
              <general-information-preview></general-information-preview>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex md6 xs12>
          <v-card>
            <v-card-title class="pb-0">
              <v-layout align-center justify-space-between fill-height>
                <v-flex xs8>
                  <h5 class="headline text-uppercase text-green">{{
                      'app.interview.diseases_and_symptoms' | trans
                    }}</h5>
                </v-flex>
                <v-flex xs4>
                  <permission-button color="primary" :container-class="`pull-right`"
                                     @click="editForm('diseases_and_symptoms')"
                                     :tooltip="{top: true, bottom: false, attach: false}"
                                     :permission="`patient_interview_manage`">
                    {{ 'app.edit'|trans }}
                  </permission-button>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-divider></v-divider>
              <diseases-and-symptoms-preview></diseases-and-symptoms-preview>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex md6 xs12>
          <v-card>
            <v-card-title class="pb-0">
              <v-layout align-center justify-space-between fill-height>
                <v-flex xs8>
                  <h5 class="headline text-uppercase text-green">{{
                      'app.interview.additional_information' | trans
                    }}</h5>
                </v-flex>
                <v-flex xs4>
                  <permission-button color="primary" :container-class="`pull-right`"
                                     @click="editForm('additional_information')"
                                     :permission="`patient_interview_manage`"
                                     :tooltip="{top: true, bottom: false, attach: false}">
                    {{ 'app.edit'|trans }}
                  </permission-button>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-divider></v-divider>
              <additional-info-preview></additional-info-preview>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex md6 xs12>
          <v-card>
            <v-card-title class="pb-0">
              <v-layout align-center justify-space-between fill-height>
                <v-flex xs8>
                  <h5 class="headline text-uppercase text-green">{{ 'app.interview.preferences' | trans }}</h5>
                </v-flex>
                <v-flex xs4>
                  <permission-button color="primary" :container-class="`pull-right`" @click="editForm('preferences')"
                                     :permission="`patient_interview_manage`"
                                     :tooltip="{top: true, bottom: false, attach: false}">{{
                      'app.edit'|trans
                    }}
                  </permission-button>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-divider></v-divider>
              <preferences-preview></preferences-preview>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex md6 xs12>
          <v-card>
            <v-card-title class="pb-0">
              <v-layout align-center justify-space-between fill-height>
                <v-flex xs8>
                  <h5 class="headline text-uppercase text-green">{{ 'app.interview.custom_questions' | trans }}</h5>
                </v-flex>
                <v-flex xs4>
                  <permission-button color="primary" :container-class="`pull-right`"
                                     @click="editForm('custom_questions')"
                                     :tooltip="{top: true, bottom: false, attach: false}"
                                     :permission="`surveys_create`">{{
                      'app.edit'|trans
                    }}
                  </permission-button>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-divider></v-divider>
              <custom-question-preview></custom-question-preview>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid v-if="!hasInterview && !formEditing">
      <interview-form @saved="interviewFormSaved"></interview-form>
    </v-container>
    <v-container fluid v-if="hasInterview && formEditing">
      <v-layout row wrap>
        <v-flex md12 xs12>
          <v-card>
            <v-card-title class="pb-0">
              <v-layout align-center justify-space-between fill-height>
                <v-flex xs12>
                  <h5 v-if="form === 'general_information'" class="headline text-uppercase text-green">
                    {{ 'app.interview.general_information' | trans }}</h5>
                  <h5 v-if="form === 'diseases_and_symptoms'" class="headline text-uppercase text-green">
                    {{ 'app.interview.diseases_and_symptoms' | trans }}</h5>
                  <h5 v-if="form === 'additional_information'" class="headline text-uppercase text-green">
                    {{ 'app.interview.additional_information' | trans }}</h5>
                  <h5 v-if="form === 'preferences'" class="headline text-uppercase text-green">
                    {{ 'app.interview.preferences' | trans }}</h5>
                  <h5 v-if="form === 'custom_questions'" class="headline text-uppercase text-green">
                    {{ 'app.interview.custom_questions' | trans }}</h5>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text class="pt-0">
              <v-divider></v-divider>
              <general-information-form
                  @saved="formSaved()"
                  @canceled="formCanceled()"
                  :show-save-button="true"
                  v-if="form === 'general_information'"
              >
              </general-information-form>
              <diseases-and-symptoms-form
                  @saved="formSaved()"
                  @canceled="formCanceled()"
                  :show-save-button="true"
                  v-if="form === 'diseases_and_symptoms'"
              >
              </diseases-and-symptoms-form>
              <additional-info-form
                  @saved="formSaved()"
                  @canceled="formCanceled()"
                  :show-save-button="true"
                  v-if="form === 'additional_information'"
              >
              </additional-info-form>
              <preferences-form
                  @saved="formSaved()"
                  @canceled="formCanceled()"
                  :show-save-button="true"
                  v-if="form === 'preferences'"
              >
              </preferences-form>
              <custom-questions-form
                  @saved="formSaved()"
                  @canceled="formCanceled()"
                  :show-save-button="true"
                  v-if="form === 'custom_questions'"
              >
              </custom-questions-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<style>
.subheading {
  font-weight: 700;
  font-size: 14px !important;
}

.headline {
  font-size: 20px !important;
}
</style>
<script>
import {mapGetters, mapActions} from "vuex";

export default {
  props: {
    patientId: {
      type: Number,
      required: true,
    },
    interviewId: {
      type: Number,
      required: false,
      default: null
    },
  },
  data() {
    return {
      form: null,
      dataInterviewId: null
    }
  },
  async created() {
    this.dataInterviewId = this.interviewId;
    if (this.hasInterview) {
      await this.fetchInterview({patientId: this.patientId, interviewId: this.dataInterviewId});
      await this.fetchLikeables({patientId: this.patientId})
    }
  },
  computed: {
    ...mapGetters(['patient']),
    hasInterview: function () {
      return this.dataInterviewId !== null;
    },
    formEditing: function() {
      return this.form !== null;
    }
  },
  methods: {
    ...mapActions(['fetchPatient', 'fetchInterview', 'fetchLikeables']),
    editForm(form) {
      this.form = form;
    },
    async formSaved() {
      if (this.form === 'general_information') {
        await this.fetchPatient(this.patientId);
      }
      this.form = null
    },
    formCanceled() {
      this.form = null;
    },
    async interviewFormSaved(payload) {
      this.dataInterviewId = payload.id;
      await this.fetchPatient(this.patientId);
      await this.fetchInterview({patientId: this.patientId, interviewId: this.dataInterviewId});
      await this.fetchLikeables({patientId: this.patientId});
    }
  }
}
</script>
<style scoped>
.v-card {
  height: 100%;
}
</style>
